import { z } from 'zod';

export const crmTypeValues = {
  COMPANY: 1,
  CONTACT: 2,
} as const;

export const customerSchema = z.object({
  id: z.uuid(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  crmType: z.number().int(),
  companyId: z.uuid().nullable(),
  companyName: z.string().nullable(),
  organizationId: z.uuid().nullable(),
});

export type Customer = z.infer<typeof customerSchema>;

export const findCustomersInput = z.object({
  offset: z.number().int().nonnegative().default(0),
  limit: z.number().int().positive().max(100).default(100),
  organizationIds: z.array(z.uuid()).optional(),
});

export type FindCustomersInput = z.infer<typeof findCustomersInput>;

export const paginatedCustomersSchema = z.object({
  data: z.array(customerSchema),
  total: z.number(),
  offset: z.number(),
  limit: z.number(),
});

export type PaginatedCustomers = z.infer<typeof paginatedCustomersSchema>;
